angular.module('ccasignup.constants', [])
    .constant('parentTeacherConferenceLocationTypes', {
        InPerson: 0,
        Online: 1,
        Both: 2,
    });